import { getContext, setContext } from "svelte";
import type { ChatController } from "./chat-controller";

const CHAT_CONTEXT_KEY = Symbol("chat-context");

export function setChatContext(controller: ChatController) {
  setContext(CHAT_CONTEXT_KEY, controller);
}

export function getChatContext(): ChatController {
  return getContext(CHAT_CONTEXT_KEY) as ChatController;
}
